export default {
  attachFiles: 'Attach file',
};
